<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5">Ver Plan de Pago Predeterminado</v-card-title>
        <v-card-text>
          <p class="mb-0"><b>Nombre:</b> {{ input.nombre }}</p>
          <p><b>Unidad aplicable:</b> {{ input.unidad ? input.unidad.nombre : '-' }}</p>

          <v-data-table
            :headers="headers"
            :items="input.conceptos"
            :itemsPerPage="-1"
            :loading="loading || loadingunidad"
            class="elevation-2"
            disable-pagination
            hide-default-footer
          >
          </v-data-table>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = !dialog">Cerrar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      loadingunidad: false,
      msg: '',
      input: { conceptos: [], unidad: {} },
      headers: [
        { text: 'Concepto', value: 'nombre' },
        { text: 'Maximo Cuotas', value: 'max_cuotas', width: 150 },
        { text: '', value: 'actions', width: 50 },
      ],
    }),
    components: {},
    methods: {
      openmodal(item) {
        this.dialog = true;
        this.input.conceptos = [];
        this.input.unidad = {};
        this.getdata(item.id);
      },
      getdata(id) {
        let vue = this;
        this.loading = true;

        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos/${id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            vue.input = data;
            vue.loading = false;
            vue.getunidad(data.unidad_negocio_id);
            window.console.log(data);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      async getunidad(id) {
        var vue = this;
        vue.loadingunidad = true;
        var sql = gql`
          query {
            Negocio(id:${id}) {
              id
              nombre
            }
          }
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.Negocio;
            if (dat) vue.input.unidad = dat;
            vue.loadingunidad = false;
          })
          .catch((error) => {
            vue.loadingunidad = false;
            window.console.error(error);
          });
      },
    },
  };
</script>
